module.exports = __webpack_public_path__ + "img/aec_logo@2x.2f93159a.png";